import { HoudiniClient, cache } from '$houdini'
import sessionStore, { getSession } from 'stores/session'
import buildApiUrl from 'utility/build-api-url'

let session = getSession()

sessionStore.subscribe(newSession => {
	session = newSession
	// Clear cache on logout
	if (!session?.authToken) {
		cache.reset()
	}
})

function hasExtensionsNotes(error: unknown): error is { extensions: { notes: string } } {
	return (
		typeof error === 'object' &&
		error !== null &&
		'extensions' in error &&
		(error as { extensions: { notes: string } }).extensions.notes !== undefined
	)
}

const { apiURL } = buildApiUrl()

const client = new HoudiniClient({
	url: apiURL,
	fetchParams(ctx) {
		// BFF auth: cookie is sent automatically; do not send auth-token header.
		// Legacy auth: send auth-token header only when a real token exists.
		const isBff = session.authToken === 'bff-cookie'
		const hasToken = !isBff && !!session.authToken
		return {
			credentials: 'include',
			headers: {
				// Only send auth-token when we have a real token value.
				// Previously this sent an empty string when no session existed, which
				// could cause the API to reject the request instead of falling back
				// to cookie-based authentication.
				...(hasToken && { 'auth-token': session.authToken }),
				'apollographql-client-name': 'EnterpriseWeb',
				'apollographql-client-version': '__buildVersion__',
				'Content-Type': 'application/json',
				'x-apollo-operation-name': ctx.document.name,
			},
		}
	},
	// We're used to errors throwing with our custom api fetch, so let's keep that behavior
	// TODO, maybe we can add errors to a more permanent log here?
	throwOnError: {
		operations: ['all'],
		error: errors => {
			if (errors.length > 1) {
				console.error('%cGraphQL Query Errors: %o', 'font-size:24px; font-weight:700; color:red;', errors)
			} else {
				console.error('%cGraphQL Query Error: %o', 'font-size:24px; font-weight:700; color:red;', errors[0])
			}
			let message = errors[0].message
			if (hasExtensionsNotes(errors[0])) {
				message += `\r\nAdvanced Details:\r\n${errors[0].extensions.notes}`
			}
			throw new Error(message, { cause: errors[0] })
		},
	},
})
export default client
